<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="content-6">
        <div class="content-6__submenu">
          <div class="menubar">
            <div
              v-for="(menu, key) in menuList"
              :key="key"
              class="menubar__item"
              :class="{active: currentData.type === key }"
            >
              <span class="menubar__item__text" @click="changeSubMenulist(key)">{{ menu }}</span>
              <div class="menubar__item__lightborder"></div>
            </div>
          </div>
        </div>
        <div v-if="currentData.type !== 'normal' && currentData.type !== 'kl8'" class="content-6__chartbox">
          <div class="content-6__chartbox__control">
            <div class="menubar">
              <div class="menubar__previous" style="display: none">
                <!-- <img class="menubar__previous__img" src="@/assets/desktop/img/slider-left.svg" alt=""> -->
              </div>
              <div class="menubar__next" style="display: none">
                <!-- <img class="menubar__next__img" src="@/assets/desktop/img/slider-right.svg" alt=""> -->
              </div>
              <div class="menubar__itembox">
                <div
                  v-for="subMenu in subMenulist"
                  :key="subMenu.code"
                  class="menubar__item"
                  :class="{active: currentData.code === subMenu.code}"
                >
                  <span class="menubar__item__text" @click="changeSubMenuItem(subMenu)">{{ subMenu.name }}</span>
                  <div class="menubar__item__lightborder"></div>
                </div>
              </div>
            </div>
          </div>
          <component
            :is="currentComponent"
            v-if="currentData.type !== 'kl8' && currentData.type !== 'normal'"
            :lottery-code="currentData.code"
            :lottery-type="currentData.type"
          />
        </div>
        <div class="content-6__other">
          <div v-for="(bottomLottery, idx) in bottomMenu" :key="`bottomLottery-${idx}`" class="c6-linkbox">
            <div class="c6-linkbox__left">
              <nuxt-link :to="`/lottery/trend/${bottomLottery.code}`">
                <div class="c6-linkbox__left__icon">
                  <img :src="bottomLottery.iconURL" alt="">
                </div>
              </nuxt-link>
              <div class="c6-linkbox__left__name">
                <span class="h-content-title">{{ bottomLottery.name }}</span>
              </div>
            </div>
            <div class="c6-linkbox__right">
              <div v-for="tabBar in tabBarList" :key="tabBar.label" class="linkgroup">
                <div class="linkgroup__title">
                  <span class="linkgroup__title__text">{{ tabBar.label }}</span>
                </div>
                <div class="linkgroup__content">
                  <nuxt-link v-for="(item, index) in tabBar.list" :key="index" class="button-primary" :to="item.link(bottomLottery.code)">
                    <span class="button-primary__text">{{ item.label }}</span>
                  </nuxt-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 兩面橫版走勢
import LiangMianHengBanZouShihContent from '@/components/web/pages/trend/LiangMianHengBanZouShih/content'
// 定位橫版走勢
import DingWeiHengBanZouShihContent from '@/components/web/pages/trend/DingWeiHengBanZouShih/content'
// 和值橫版走勢
import HeJhihHengBanZouShihContent from '@/components/web/pages/trend/HeJhihHengBanZouShih/content'

import { getCpsList_web } from '@/api/desktop/trend'
import { webTrendTabbarMapping } from '@/utils/tabbarMapping'
export default {
  name: 'ZouShihTuBiao', // 走勢圖表
  components: {
    LiangMianHengBanZouShihContent,
    DingWeiHengBanZouShihContent,
    HeJhihHengBanZouShihContent
  },
  data() {
    return {
      menuList: {
        pk10: 'PK10',
        k3: '快3',
        syx5: '11选5',
        ssc: '时时彩',
        kl8: '快乐8',
        xy28: '幸运28',
        kl10: '快乐十分',
        normal: '一般彩票'
      },
      subMenulist: [],
      currentComponent: null,
      tabBarList: [],
      currentData: {
        code: '',
        type: '',
        name: '',
        iconURL: ''
      },
      bottomMenu: []
    }
  },
  watch: {
    'currentData.type': {
      immediate: true,
      handler(type) {
        this.changeCurrentComponent(type)
      }
    }
  },
  created() {
    this.currentData.type = 'pk10'
    this.getSubMenuList(this.currentData.type)
    this.getTabBarList()
  },
  methods: {
    async getSubMenuList(type) {
      const [data, error] = await getCpsList_web(type)
      if (error) return

      const [publicCpMap, publicCpMapError] = await this.$store.dispatch('lottery/getLotteryMap')
      if (publicCpMapError) return

      for (const x of data) {
        const obj = {}
        obj.name = x.name
        obj.code = x.code
        obj.iconURL = publicCpMap[x.code].iconURL
        this.subMenulist.push(obj)
        this.bottomMenu.push(obj)
      }

      this.currentData.code = this.subMenulist[0].code
      this.currentData.name = this.subMenulist[0].name
      this.currentData.iconURL = this.subMenulist[0].iconURL
      if (this.currentData.type !== 'normal' && this.currentData.type !== 'kl8') {
        this.handleArrowButton()
      }
    },
    handleArrowButton() {
      const menuBarItemBox = document.querySelector('.menubar__itembox')
      menuBarItemBox.onscroll = function() {
        document.querySelector('.menubar__next').classList.add('active')
        const scrollWidth = menuBarItemBox.scrollWidth
        const offsetWidth = menuBarItemBox.offsetWidth
        const scrollLeftDis = menuBarItemBox.scrollLeft
        if (scrollLeftDis > 10) {
          document.querySelector('.menubar__previous').classList.add('active')
        } else {
          document.querySelector('.menubar__previous').classList.remove('active')
        }

        const scrollDistance = scrollWidth - offsetWidth

        if (scrollDistance === scrollLeftDis) {
          document.querySelector('.menubar__next').classList.remove('active')
        } else {
          document.querySelector('.menubar__next').classList.add('active')
        }
      }
    },
    getTabBarList() {
      let type = this.currentData.type
      if (this.currentData.type === 'syx5') type = '11x5'
      if (this.currentData.type === 'normal') type = 'others'
      this.tabBarList = webTrendTabbarMapping[type]
    },
    async changeSubMenulist(type) {
      this.subMenulist = []
      this.bottomMenu = []
      this.currentComponent = null
      await this.getSubMenuList(type)
      this.currentData.type = type
      this.getTabBarList()
    },
    changeSubMenuItem(item) {
      this.currentData.code = item.code
      this.currentData.name = item.name
      this.currentData.iconURL = item.iconURL
    },
    changeCurrentComponent(type) {
      switch (type) {
        case 'pk10':
          this.currentComponent = LiangMianHengBanZouShihContent
          break
        case 'xy28':
        case 'k3':
          this.currentComponent = HeJhihHengBanZouShihContent
          break
        case 'kl10':
        case 'ssc':
        case 'syx5':
          this.currentComponent = DingWeiHengBanZouShihContent
          break
        case 'kl8':
        case 'normal':
          this.currentComponent = null
          return
      }
    }
  }
}
</script>

<style scoped>
.menubar__previous.active, .menubar__next.active {
  display: block !important;
}
</style>
